import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { ESTADOS } from '../requestStates';
import styles from './RequestFiltersPanel.module.css';

// Campos ordenables: los mismos que se ordenan con clic en la cabecera de la tabla.
const SORT_FIELDS = [
  ['estadoOrder', 'Estado'],
  ['fechaCreacionDateOrder', 'Creación'],
  ['fechaCreacionOrder', 'Retiro'],
  ['fechaResolucionOrder', 'Devolución'],
];
// Solo un campo ordena a la vez (misma regla que handleSortChange de las listas).
const SORT_RESET = Object.fromEntries(SORT_FIELDS.map(([field]) => [field, 'undefined']));

// Filtros de solicitudes en móvil y tablet portrait (en escritorio van en la cabecera de la tabla).
// Escribe en el mismo selectedFilters de la lista con onChange(patch).
const RequestFiltersPanel = ({ filters, onChange, showUserFilter = false }) => {
  const [open, setOpen] = useState(false);

  const activeCount = [
    filters.nroSolicitud,
    showUserFilter && filters.nombreCorreo,
    filters.estado !== 'undefined',
    filters.fechaCreacionDate,
    filters.fechaCreacion,
    filters.fechaResolucion,
  ].filter(Boolean).length;

  const sortField = SORT_FIELDS.find(([field]) => filters[field] !== 'undefined');
  const sortValue = sortField ? `${sortField[0]}:${filters[sortField[0]]}` : '';

  const handleSortChange = (e) => {
    const [field, order] = e.target.value.split(':');
    onChange(field ? { ...SORT_RESET, [field]: order } : SORT_RESET);
  };

  const handleClear = () => {
    onChange({
      nroSolicitud: '',
      ...(showUserFilter && { nombreCorreo: '' }),
      estado: 'undefined',
      fechaCreacionDate: '',
      fechaCreacion: '',
      fechaResolucion: '',
    });
  };

  const field = (name) => (e) => onChange({ [name]: e.target.value });

  return (
    <section className={styles.panel}>
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        Filtros{activeCount > 0 && ` (${activeCount})`}
        {open ? <FaChevronUp /> : <FaChevronDown />}
      </button>

      {open && (
        <div className={styles.fields}>
          <label className={styles.field}>
            <div className={styles.label}>ID</div>
            <input type="text" inputMode="numeric" className={styles.input} value={filters.nroSolicitud} onChange={field('nroSolicitud')} />
          </label>
          {showUserFilter && (
            <label className={styles.field}>
              <div className={styles.label}>Usuario</div>
              <input type="text" className={styles.input} placeholder="Nombre" value={filters.nombreCorreo} onChange={field('nombreCorreo')} />
            </label>
          )}
          <label className={styles.field}>
            <div className={styles.label}>Estado</div>
            <select className={styles.input} value={filters.estado} onChange={field('estado')}>
              {Object.keys(ESTADOS).map((key) => (
                <option key={key} value={key}>{ESTADOS[key]}</option>
              ))}
            </select>
          </label>
          <label className={styles.field}>
            <div className={styles.label}>Creación</div>
            <input type="date" className={styles.input} value={filters.fechaCreacionDate} onChange={field('fechaCreacionDate')} />
          </label>
          <label className={styles.field}>
            <div className={styles.label}>Retiro</div>
            <input type="date" className={styles.input} value={filters.fechaCreacion} onChange={field('fechaCreacion')} />
          </label>
          <label className={styles.field}>
            <div className={styles.label}>Devolución</div>
            <input type="date" className={styles.input} value={filters.fechaResolucion} onChange={field('fechaResolucion')} />
          </label>
          <label className={styles.field}>
            <div className={styles.label}>Ordenar por</div>
            <select className={styles.input} value={sortValue} onChange={handleSortChange}>
              <option value="">Sin orden</option>
              {SORT_FIELDS.map(([name, label]) => (
                <React.Fragment key={name}>
                  <option value={`${name}:desc`}>{label} ↓</option>
                  <option value={`${name}:asc`}>{label} ↑</option>
                </React.Fragment>
              ))}
            </select>
          </label>
          <button type="button" className={styles.clear} onClick={handleClear} disabled={activeCount === 0}>
            Limpiar filtros
          </button>
        </div>
      )}
    </section>
  );
};

export default RequestFiltersPanel;
